import React from 'react';

import styles from './Overlay.module.scss';

interface IOverlay extends React.PropsWithChildren {
  visible: boolean;
}

const Overlay: React.FC<IOverlay> = props => {
  const { children, visible } = props;
  return (
    <>
      {visible && (
        <div className={styles.overlay}>
          <div className={styles.children}>{children}</div>
        </div>
      )}
    </>
  );
};

export default Overlay;
